import { createGlobalStyle } from 'styled-components'

import { theme } from './theme'

const GlobalStyles = createGlobalStyle`
  * {
    font-family: 'Roboto', sans-serif;
    box-sizing: border-box;
  }
  html {
    overflow-y: scroll;
  }
  body {
    overflow-x: hidden;
    margin: unset;
  }
  .flex-1 {
    flex: 1;
  }
  .bold {
    font-weight: bold;
  }
  .anticon svg {
    color: ${theme.primaryColor};
  }
  .fit-alert .anticon svg {
    color: unset;
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: white;
    border-color: black;
    &:after {
      border-color: black;
    }
  }
  .ant-table-thead > tr > th {
    color: ${theme.textColor} !important;
    text-align: left;
    font-weight: 600;
    border-bottom: 1px solid ${theme.white};
  }
  .ant-table-thead > tr > th[colspan]:not([colspan='5']) {
    border: solid brown 1px;
  }
  .ant-table-tbody > tr > td {
    color: ${theme.textColor} !important;
    text-align: left;
  }
  .ant-scrolling-effect {
    width: 100% !important;
  }
  .ant-modal {
    top: 3rem;
  }
  .ant-picker-disabled,
  .ant-select-disabled {
    .ant-picker.ant-picker-disabled,
    .ant-select-selector {
      color: ${theme.lightBlack} !important;
      background: unset !important;
      border: unset !important;
    }
    .ant-picker-suffix,
    .ant-select-arrow {
      display: none;
    }
  }
  .ant-picker-input > input[disabled],
  .ant-picker.ant-picker-disabled {
    color: ${theme.lightBlack} !important;
    background: unset !important;
    border: unset !important;
  }
  .p-datatable .p-datatable-thead > tr > th {
    background: white !important;
  }
  .ant-table-content {
    font-size: 0.85rem;
  }
  .dashboard-badge svg {
    fill: ${theme.secondaryDarkGray};
  }
  .menu-badge .ant-badge-count {
    transform: translate(80%, -50%);
  }
  .menu-badge svg {
    fill: ${theme.textColor};
    transition: all ease 300ms !important;
  }
  .ant-menu-item-active .menu-badge svg {
    fill: ${theme.primaryColor};
  }
  .menu-badge .ant-badge-multiple-words {
    padding: 0 0.25rem;
  }
  .ant-badge-count {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .display-none {
    display: none !important;
  }
  .p-datepicker table td > span.p-highlight {
    background: ${theme.primaryColor};
    color: #fff;
    border-radius: 3px;
    box-shadow: none;
  }
  .p-datepicker table td > span:focus {
    box-shadow: none;
  }
  .p-datepicker table td > span {
    border-radius: 3px;
  }
  .p-calendar {
    width: 100%;
  }
  .p-calendar:hover {
    color: ${theme.primaryColor} !important;
  }
  .p-component {
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    box-shadow: none;
    cursor: pointer;
  }
  .p-inputwrapper-focus {
    box-shadow: none;
    border: none;
  }
  .p-inputwrapper {
    height: 32px;
    box-shadow: none;
  }
  .p-inputtext:enabled:hover {
    border-color: ${theme.primaryColor};
  }
  .p-button {
    background: ${theme.primaryColor};
    border-color: ${theme.primaryColor};
  }
  .p-button:enabled:hover {
    background: #54739e;
    border-color: #54739e;
    color: #fff;
  }
  .p-datepicker:not(.p-disabled) table td span:not(.p-highlight):not(.p-disabled):focus {
    box-shadow: none;
  }
  .p-calendar-w-btn-right .p-inputtext {
    color: rgba(0, 0, 0, 0.85);
  }
  .p-datepicker table {
    font-size: .9rem;
  }
  .p-datepicker .p-timepicker span {
    font-size: .9rem;
  }
  .p-datepicker table td.p-datepicker-today > span.p-highlight {
    background: ${theme.primaryColor};
    color: #fff;
    border-radius: 3px;
    box-shadow: none;
  }
  .p-button.p-button-secondary.p-button-text:enabled:focus {
    box-shadow: none;
  }
  .p-inputtext:enabled:focus {
    box-shadow: none;
    border-color: ${theme.primaryColor};
  }
  .p-button:focus {
    box-shadow: none;
  }
  .clear-button {
    color: #607D8B;
    background: transparent;
    border: none;
  }
  .clear-button:hover {
    background: #e9ecef;
    color: #607D8B;
  }
  .p-datepicker table td {
    padding: 0.05rem !important;
  }
  .p-datepicker .p-timepicker {
    padding: .02rem;
  }
  .p-datepicker .p-datepicker-buttonbar {
    padding: .3rem;
  }
  #simulation-table .ant-table-cell {
    vertical-align: top;
  }
  .p-radiobutton .p-radiobutton-box:not(.p-disabled).p-focus {
    box-shadow: none;
    border-color: ${theme.primaryColor};
  }
  .p-radiobutton .p-radiobutton-box:not(.p-disabled):not(.p-highlight):hover {
    border-color: #355891c7;
  }
  .p-radiobutton .p-radiobutton-box.p-highlight:not(.p-disabled):hover {
    border-color: #355891c7;
    background-color: #355891c7;
  }
  .p-radiobutton .p-radiobutton-box.p-highlight {
    background-color: ${theme.primaryColor};
    border-color: ${theme.primaryColor};
  }
  #radio-button .p-disabled, .p-disabled * {
    background-color: gray !important;
    border-color: gray;
  }
  .map-container {
    width: 100%;
    height: 60vh;
  }
  ::-webkit-scrollbar {
    width: 0.25rem;
    height: 0.25rem;
  }
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 0.25rem ${theme.lightGray};
    border-radius: 0.25rem;
  }
  ::-webkit-scrollbar-thumb {
    background: ${theme.scrapBlue};
    border-radius: 10px;
    height: 4rem;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: ${theme.darkGray};
  }
  .zebra-even {
    background-color: #ffffff;
  }  
  .zebra-odd {
    background-color: #0c68fc00;
  }
  .ant-table-tbody > tr:hover > td {
    background-color: transparent !important;
    color: inherit !important;
  }
  .ant-table-row.ant-table-row-level-0 > tr:hover {
    background-color: transparent !important;
    color: inherit !important;
  } 
  .checkbox-label {
    display: flex;
    align-items: center;
  }
  .carrier-selection-table {
    flex: 1;
    display: flex;
    width: auto;
    overflow-y: hidden;
    min-width: 25rem;
    max-width: 50rem;
    .ant-spin-nested-loading {
      display: flex;
      flex: 1;
      .ant-spin-container {
        display: flex;
        flex: 1;
        .ant-table {
          display: flex;
          flex: 1;
          .ant-table-container {
            display: flex;
            flex: 1;
            flex-direction: column;
            .ant-table-header {
              display: flex;
              overflow: unset !important;
              border-bottom: 1px solid #00000040;
              .ant-table-thead > tr > th {
                padding: 0.25rem 0.75rem 0.25rem 0.5rem !important;
                font-size: 0.75rem;
                .ant-table-column-title {
                  text-align: center;
                }
              }
            }
            .ant-table-body {
              display: flex;
              flex: 1;
            }
            .ant-table-content {
              display: flex;
              flex: 1;
            }
          }
        }
      }
    }
    .ant-table-tbody > tr {
      transition: all ease-in-out 300ms;
      > td {
        padding: 0.5rem 0;
        background-color: unset;
        background: unset;
      }
    } 
    .ant-table-tbody > tr.ant-table-row-selected {
      background-color: ${theme.lightGray}50;
      > 
      td {
        background-color: unset !important;
        background: unset !important;
      }
    }
    .ant-table-tbody > tr.row-CONFIRMED_CARRIER {
      background-color: ${theme.carrierTableColors.CONFIRMED};
    }
    .ant-table-tbody > tr.row-PENDING_CARRIER {
      background-color: ${theme.carrierTableColors.PENDING};
    }
    .carrier-column-header {
      justify-content: center;
      align-items: center;
    }
    th.ant-table-cell:has(.column-SELECTED_EQUIPMENT_COLUMN) {
      background-color: ${theme.carrierTableColors.SELECTED_EQUIPMENT_COLUMN};
    }
    .ant-table-body {
      overflow-y: scroll;
    }
    .ant-table-cell {
      padding: unset !important;
      height: 2.5rem;
    }
  }
  .carrier-table-status-header {
    align-items: flex-end;
    justify-content: space-between;
    .ant-tooltip {
      max-width: unset;
    }
    .ant-form-item-control {
      transform: translateY(-1.675rem);
    }
  }
  .carrier-table-status-ref-sample {
    height: 1.5rem;
    width: 2rem;
    border-radius: 0.25rem;
    border: 1px solid #00000030;
  }
  .required-asterisk {
    display: inline-block;
    margin-right: 4px;
    color: #ff4d4f;
    font-size: 14px;
    font-family: SimSun, sans-serif;
    line-height: 1;
  }
  .carrier-table-status-equipment-header {
    text-align: center;
  }
  .carrier-table-status__tooltip-refs {
    max-width: unset;
  }
  .carrier-table-status__tooltip-refs__title {
    gap: 0.5rem;
    padding: 0.5rem;
  }
  .carrier-table-status__tooltip-refs__status-row {
    gap: 0.25rem;
    align-items: center;
  }
  .carrier-table-status__tooltip-refs__status-row__description {
    white-space: nowrap;
  }
  .disabled-input-opacity {
    opacity: 0.5;
  }
  .accept-ticket-modal {
    .carrier-form-row {
      .ant-form-item {
        margin-bottom: unset;
        .ant-form-item-row {
          flex-wrap: wrap;
        }
      }
    }
    .ant-form {
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      gap: 0.675rem;
      margin-bottom: 1.5;
    }
  }
  .add-additional-data-ticket-modal {
    .hide-feedback .ant-form-item-explain {
      display: none;
    }
    .ticket-sap-row {
      min-height: 4rem;
      align-items: flex-start;
      .ant-input-affix-wrapper-disabled {
        color: unset !important;
        background-color: unset !important;
        border: none !important;
        box-shadow: none;
      }
    }
    .carrier-form-row {
      .ant-form-item {
        margin-bottom: unset;
      }
    }
  }
  .asnum-cell {
    gap: 0.75rem;
    justify-content: space-between;
    span {
      white-space: nowrap;
    }
  }
  .expandable-row {
    cursor: pointer;
  }
  .stripped-table tr:not(.expandable-row):nth-child(even) {
    background-color: ${theme.lightGray}50;
  }
  .stoplight {
    height: 5rem;
    width: 0.5rem;
    position: relative;
  }
  .barlight {
    width: 0.35rem;
    min-height: 100%;
  }  
  .stoplight.yellow, .barlight.yellow {
    background-color: ${theme.status.yellow} !important;
  }  
  .stoplight.green, .barlight.green {
    background-color: ${theme.status.green} !important;
  }  
  .stoplight.red, .barlight.red {
    animation: pulse 2s infinite;
    background-color: ${theme.status.red} !important;
  }
  @-webkit-keyframes pulse {
    0% {
      -webkit-box-shadow: 0 0 0 0 #e1394d41;
    }
    70% {
      -webkit-box-shadow: 0 0 0 0.5rem #e1394d00;
    }
    100% {
      -webkit-box-shadow: 0 0 0 0 #e1394d00;
    }
  }
  @keyframes pulse {
    0% {
      -moz-box-shadow: 0 0 0 0 #e1394d41;
      box-shadow: 0 0 0 0 #e1394d41;
    }
    70% {
      -moz-box-shadow: 0 0 0 0.5rem #e1394d00;
      box-shadow: 0 0 0 0.5rem #e1394d00;
    }
    100% {
      -moz-box-shadow: 0 0 0 0 #e1394d00;
      box-shadow: 0 0 0 0 #e1394d00;
    }
  }
  .ant-btn-default {
  background-color: #fbf8faff;
  }  
  .expandable-row:hover {
    background-color: #35589110 !important;
  }  

  .ant-scroll-number {
    transform: translate(190%, -10%) !important;
  }
  .ant-menu-item.ant-menu-item-selected {
  padding-left: 1.5rem !important;
  }
  .ant-menu-item {
  padding-left: 1.5rem !important;
  }
  .table-layout:hover {
    background-color: #35589110;
  }
  .bYrABc .filters-container .filters-list {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    height: 100%;
    overflow-y: hidden !important;
  }
    ::-webkit-scrollbar-thumb {
      background: #35589110;
      border-radius: 10px;
      height: 4rem;
  }
  .ant-table-row-level-0.expandable-row.odd-row:hover {
    background: #96bdfc65 !important;
  }
  .ant-select-selection-search {
    overflow-y: hidden !important;
  }
  .ant-table tr:not(.expandable-row):nth-child(even) { 
    background-color: #f1f1f173 !important; 
  }
  .ant-table-expanded-row {
    .ant-table {
      margin-inline: unset !important;
    }
  }
  .ant-table-thead {
    border-radius: unset !important;
  }  
  .expandable-row {
    background-color: #ffffff !important;
  }  
  .expandable-row.odd-row {
    background-color: #f1f1f173 !important; 
  }
  .ant-table-row:hover {
  background-color: #96bdfc65 !important;
  }
  .ant-table-tbody > tr:hover > td {
  background-color: ${theme.rowHover} !important;
  }
  .column-width {
    max-width: 4rem;
  }
  .text-styles-row {
    overflow-wrap: break-word;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: wrap;
    align-content: center;
  }
  .tag-hidden {
    width: 90%;
    background-color: transparent;
    border: none;
    overflow-wrap: break-word;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: wrap;
    align-content: center;
  }
  .column-id.text-styles-row {
    text-align: center;
    padding: 0.5rem;
    margin-left: -10px;
  }
  .ant-btn.ant-btn-default.ant-dropdown-trigger {
    background-color: transparent;
    border: none;
  }
  .ant-table-tbody.zebra-even {
    background-color: #0c68fc00;
  }
  .submenu-Ident {
    margin-left: 12px;
  }

  .custom-column {
    min-width: 7rem;
  }
  .custom-column-2 {
    min-width: 10rem;
  }
  .custom-column-3 {
    min-width: 3.75rem;
  }
  .ant-menu.ant-menu-submenu-title {
      transition: none !important;
  }
  .icon-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: #355891
    !important; 
    border: none !important; 
    border-radius: 0.25rem;
    padding: 10px;
    color: white; 
  }
  .icon-button svg {
    color: white; 
    width: 24px; 
    height: 24px;
  }
  .icon-button-right {
    margin-right: -5px;
  }
  .button-style {
    background-color: #209882;
    width: 9.5rem;
    height: 2rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .form-item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .form-item label {
    flex: 1;
    text-align: right;
  }
  .form-item input {
    flex: 2;
  }
  .form-item {
    margin-bottom: 0.5rem;
    margin: 0.5rem 0; 
  }
  .input-field {
    width: 16rem;
  }
  .input-field-railcar {
    max-width: 10rem;
    min-width: 6rem;
    flex: 1 !important;
    min-width: 0!important;
  }

  .finish-button {
    background-color: ${theme.primaryColor};  
  }

  .finish-loading-button {
    background-color: ${theme.primaryColor};  
    height: 2.5rem;
    padding: 0.5rem;
    padding-left: 0.75rem;
  }

  .button-state {  
    height: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .donwload-button {
    background-color: #209882;
    width: 9.15rem !important;
    height: 2rem !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .finished-button {
    background-color: #209882;
    width: 14rem;
    flex: 1 1 48%;
  }
  .div-button {
    display: flex;
    justify-content: flex-end;
    margin-right: 3rem;
    margin-bottom: 10rem;
  }
  .table-footer {
    margin-bottom: 5rem;
  }
  .footer-button {
      width: 10rem;
      margin-bottom: 3rem;
      margin-top: 2rem;
      margin-right: -1rem;
  }
  .form-select {
    width: 16rem;
  }
  .tabs-table-custom{
    margin-left: 1rem;
  }
  .icon-row {
    margin-right: 4px;
  }
  .divider-modal {
    border-color: gray;
    border-width: 1;
    margin-top: 2px;
  }
  .column-actions {
    width: 6.75rem;
  }
  .tabs-offset {
    padding-left: 0.75rem;
  }
  .modal-titles {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 2px;
  }
  .entity-modal {
    .ant-modal-title {
      font-size: 1.5rem;
      font-weight: bold;
    }
    .ant-picker {
      width: 100%;
    }
    .ant-form-item-control {
    flex: 2;
    }
    .ant-form-item-label:not(.ant-list-item-meta-description .ant-form-item-label) {
      flex: 1;
      min-width: 12rem;
      width: fit-content;
    }
    .ant-modal-header {
      padding-bottom: 1rem;
      border-bottom: 1px solid ${theme.gray} !important;
    }
    .ant-modal-body {
      padding: 1rem 0
    }
    &.railcar-modal {
      .ant-upload-list {
        display: none !important;
      }
    }
  }
  .blocktrain-view__header {
    gap: 1.5rem;
    padding: 1rem;
    align-items: flex-end
  }

  .status-monitor {
    max-width: 2rem;
    width: 100%;
  }

  .blocktrain-view__header {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .blocktrain-view__header__monitor-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    width: 100%;
    align-items: flex-end
  }

  @media (max-width: '48rem') {
    .blocktrain-view__header {
      flex-direction: column;
    }
  
    .blocktrain-view__header__monitor-wrapper {
      justify-content: center;
      width: 100%;
    }
  
    .blocktrain-view__header__monitor-wrapper .status-monitor {
      margin-bottom: 10px;
    }
  
    .blocktrain-view__header .ant-btn {
      width: 10% !important;
      margin-left: '1rem !important';
    }
  }

  .border-unset-material {
    border: unset;
    width: 24rem !important;
  }

  .border-unset {
    border: unset
  }
  .input-like-div {
    display: flex;
    align-items: center;
    gap: 0.15rem; 
    padding: 0.275rem 0.75rem; 
    border: 1px solid  ${theme.gray};
    border-radius: 0.4275rem !important;
    color: ${theme.black};
    min-height: 2rem;
  }
  .input-like-div-admin {
    display: flex;
    align-items: center;
    gap: 0.5rem; 
    padding: 0.23rem 0.75rem; 
    border: 1px solid  ${theme.gray};
    border-radius: 0.4275rem !important;
    color: ${theme.black};
    min-height: 2rem;
  }
  .status-form-admin { 
    padding: 0.201rem 0.75rem;
    border-radius: 0.5rem; 
  }
  .input-status { 
    padding: 0.205rem 0.75rem;
    border-radius: 0.25rem;
    max-width: 20rem;
    max-height: 1,98rem;
  }
  .no-wrap-text {
    white-space: nowrap !important;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .input-date { 
    padding: 0.25rem 0.75rem;

    border-radius: 0.4rem;
  }
  .input-status-form {
    display: flex;
    align-items: center;
    gap: 0.5rem; 
    padding: 0.25rem 0.5rem; 
    border: 1px solid  ${theme.gray};
    border-radius: 0.25rem;
    font-size: 0.875rem; 
    color: ${theme.black};
  }
  .button-form {
    margin-left: 1rem;
    width: 6.25rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: -1rem;
  }

  .button-cancel-save{
    height: 1.875rem;
    margin-bottom: 0.5rem;
  }
  .margin-form {
    margin-bottom: 1.37rem;
  }
  .centered-form {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .upload-file-list {
    overflow: auto;
    flex: 1;
    padding-right: 0.5rem;
    .ant-list-item {
      display: flex !important;
      align-items: flex-start !important;
      align-content: center !important;
      .ant-form-item-explain-error {
        margin-top: 0.15rem;
        font-size: 0.75rem;
        color: ${theme.red};
      }
      .ant-btn {
        margin-bottom: 1rem !important;
        margin-top: 0.25rem;
      }
      .ant-list-item-meta-content {
        margin-top: 0.25rem;
      }
    }
  }
  .UploadOutlined {
    display: flex;
    margin: 0.5rem;
    justify-content: center;
    width: 10.5rem;
  }
  .button-select-type {
    width: 10rem !important;
    margin-left: 0.25 !important;
  }
  .option-select-type {
    display: flex;
    align-items: center;
  }
  .ant-table.ant-table-ping-left .ant-table-ping-right .ant-table-scroll-horizontal {
    height: 2px !important;
  }
  .form-flex-row {
    display: flex;
    flex-wrap: wrap;
    gap: 1.5rem;
  }
  .form-item {
    width: auto;
  }
  
  .no-wrap-label .ant-form-item-label > label {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  flex: 0 1 auto;
  }
  

  .ant-modal-body {
  white-space: normal;
  overflow-wrap: break-word; 
  word-wrap: break-word;
  }

  .message-file {
    font-size: 0.630rem;
    margin-bottom: 1rem;
    color: ${theme.lightBlack} !important;
    text-align: center  !important;
  }

  .message-modal-file {
    font-size: 0.85rem;
    margin-bottom: 1rem;
    color: ${theme.lightBlack} !important;
    text-align: center;
  }

  .subtitle-modal-wrap {
  display: block;
  text-align: center;
  margin-bottom: 1.25rem;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}

  .centered-text-tooltip {
    .ant-tooltip-inner {
      text-align: center;
      min-width: 12.5rem;
      padding: 0.5rem 0.75rem;
    }
  }
`
export { GlobalStyles }
